import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  buttonRadios: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(70% - 8px)',
    }
  },
  dangerButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  multiSelects: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: 'calc(50% - 8px)'
    }
  },
  selectButton: {
    marginBottom: theme.spacing(3),
    textTransform: 'none',
  },
  selectButtonLabel: {
    justifyContent: 'flex-start',
  },
}));
